export default [
  {
    value: 'today',
    label: 'Today',
  },
  {
    value: 'yesterday',
    label: 'Yesterday',
  },
  {
    value: 'this_week',
    label: 'This week',
  },
  {
    value: 'this_month',
    label: 'This month',
  },
  {
    value: 'this_year',
    label: 'This year',
  },
  {
    value: 'last_week',
    label: 'Last week',
  },
  {
    value: 'last_month',
    label: 'Last month',
  },
  {
    value: 'last_year',
    label: 'Last year',
  },
];
